import { render, staticRenderFns } from "./CardRetur.vue?vue&type=template&id=b9da9d94&"
import script from "./CardRetur.vue?vue&type=script&lang=js&"
export * from "./CardRetur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports